import styled from 'styled-components';

// Wrapper for Header inside Card and Icon Button
export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  h3 {
    margin: 10px 0;
  }

  ${({ theme }) => theme.media.tabletPortraitUp`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    div {
      width: auto;
    }
  `}
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 50px;

  ${({ theme }) => theme.media.tabletLandscapeUp`
    flex-direction: row;

    & > *:not(:last-child) {
      margin-right: 10px;
    }
  `}
`;
